import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';

interface IProductTechnicalData {
  productTechnicalData: Types.MappedTechnicalData[];
}
export const ProductTechnicalData = ({ productTechnicalData }: IProductTechnicalData) => {
  const { t } = useTranslation('product-details');

  return (
    <>
      <h3 className="h2 mb-2">{t('title.technical-data')}</h3>
      <table className="table table-striped">
        <tbody>
          {productTechnicalData.map(({ name, value }) => {
            return (
              <tr key={name}>
                <td>
                  <strong>{name}</strong>
                </td>
                <td className="pr-0">{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
